<template>
  <v-layout column wrap justify-center align-center class="p-absolute h-100 disconected">
    <v-flex xs3>
      <v-layout column wrap justify-center align-center>
        <h1 class="my-3">
          Desconectado
        </h1>
        <small class="d-block white--text my-3">Conectese para visualizar los mensajes</small>
        <v-tooltip bottom>
          <v-btn slot="activator" icon color="k-orange-linear my-3" large @click="init">
            <v-icon>fas fa-power-off</v-icon>
          </v-btn>
          <span>Conectar</span>
        </v-tooltip>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
  export default {
    methods: {
      init() {
        this.axios.post('chat/center/online', {
          status: 1,
        }).then(({ data }) => {
          this.$auth.user().chat_center_online = data.status;
          this.$emit('complete', true);
        }).catch(() => {});
      },
    },
  };
</script>

<style scoped>
.disconected {
    top: 0;
    left: 0;
    width: 100%;
    color: #DDDDDD;
    background-color: rgba(0, 0, 0, 0.7);
  }
</style>



// WEBPACK FOOTER //
// src/components/chat_center/ConnectPanel.vue